import { State } from 'model/State';
import { postToHamsClient } from 'util/mac/api/consentHub/post';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { getCurrentContactEmail } from 'modules/auth/selectors';

export const consentHubLink = (state: State) => {
  const contactEmail = getCurrentContactEmail(state) as string;
  return fetchWithParamValidation(
    ({ userEmail }) => postToHamsClient(`/link/${userEmail}`, state),
    {
      userEmail: contactEmail,
    },
  );
};
